<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled'
                                    : props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Warehouse Name"
                  v-model="warehouse.name"
                  type="text"
                  :rules="rules.warehouseNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Warehouse Code"
                  v-model="warehouse.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="location"
                  label="Warehouse Location"
                  v-model="warehouse.location"
                  type="text"
                  :rules="rules.locationRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Warehouse Description"
                  v-model="warehouse.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="warehouse.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="warehouse.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="warehouse.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="warehouse.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="warehouse.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="warehouse.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="warehouse.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn color="primary" :loading="saveLoading" :disabled="!valid" type="submit">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import { warehouseService } from "../../services/warehouse-service";
import { Warehouse } from "../../models/model";
import { WarehouseFormRules } from "../../helpers/validation-rules";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";

export default {
  name: "WarehouseDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Warehouse",
        disabled: false,
        to: "warehouses"
      },
      {
        text: "Warehouse Detail",
        disabled: true
      }
    ],
    createdDate: "",
    updatedDate: "",
    warehouse: new Warehouse(),
    oldWarehouse: new Warehouse(),
    statusFlag: true,
    saveLoading: false,
    responseError: "",
    rules: new WarehouseFormRules()
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new warehouse
    } else {
      this.getWarehouseDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.warehouse.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

        let warehouseObj = {
          id: this.warehouse.id ? this.warehouse.id : "",
          name: this.warehouse.name,
          code: this.warehouse.code,
          location: this.warehouse.location,
          description: this.warehouse.description,
          status: this.warehouse.status
        };
        warehouseService
          .saveWarehouse(warehouseObj)
          .then(res => {
            console.log(res);
            this.goBack();
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    getWarehouseDetail(id) {
      warehouseService
        .getWarehouseDetail(id)
        .then(res => {
          this.warehouse = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.warehouse.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.warehouse.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.oldWarehouse = Object.assign({}, res.data);
          this.statusFlag = this.warehouse.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.warehouse.id) {
        this.warehouse = new Warehouse();
        this.statusFlag = true;
      } else {
        this.warehouse = Object.assign({}, this.oldWarehouse);
        this.statusFlag = this.warehouse.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/warehouses");
    }
  }
};
</script>
